<template>
  <div class="setting-popup"  v-show='boxData.judgeBox && gotDuration' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      背景视频时长调整
    </div>
    <div class="setting-popup__content">
      <div class="controls">
        <div class="controls__slider">
          <div class="controls__time">00:00</div>
          <div class="slider">
            <div class="slider__runway" :style="{width: slider.runwayLength + 'px'}" ref="runway">
              <div class="slider__bar" :style="{width: (slider.barEnd - slider.barStart) + 'px', marginLeft: slider.barStart + 'px'}"></div>
              <div class="slider__button start"
                data-usage="start"
                v-dragged="onDragged"
                ref="sliderButtonStart"
              ></div>
              <div class="slider__button end"
                data-usage="end"
                v-dragged="onDragged"
                ref="sliderButtonEnd"
              ></div>
            </div>
          </div>
          <div class="controls__time">{{durationFormat}}</div>
        </div>
        <template v-if="timeData && timeData.length">
          <div class="controls__counter counter" v-for="item in timeData" :key="item.name">
            <div class="counter__name">{{item.lang}}时间</div>
            <div class="counter__content">
              <div class="counter__minus" @click="setCounter({action: 'minus', timeDatum: item})">-</div>
              <div class="counter__number">{{item.format}}</div>
              <div class="counter__plus" @click="setCounter({action: 'plus', timeDatum: item})">+</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import popup from '../mixins/popup';
import { formatSecond } from '@/plugins/formatDuration';

export default {
  mixins: [popup],
  data () {
    return {
      // popupType: 'videoBgDuration',
      popupType: 'clipSetting.bg',

      startTime: 0,
      endTime: 0,
      startFormat: '',
      endFormat: '',
      duration: 0,
      durationFormat: '',

      timeData: [],

      timeOnOpen: {
        startTime: 0,
        endTime: 0
      },

      slider: {
        barLength: 0,
        runwayLength: 188,
        barStart: 0,
        barEnd: 1
      },
      gotDuration: false,
      buttons: []
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg'
    ])
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.setTimeData()
            .then(() => {
              this.timeOnOpen.startTime = this.startTime;
              this.timeOnOpen.endTime = this.endTime;

              this.updateSlider();
              this.gotDuration = true;
            })
        } else {
          let shouldUndo = true;
          if (this.timeOnOpen.startTime === this.startTime && this.timeOnOpen.endTime === this.endTime) {
            shouldUndo = false;
          }
          this.SelectScenes_Msg.setVideoBgDuration({
            start: this.startTime,
            end: this.endTime
          }, shouldUndo);

          this.$bus.emit('durationTip.update');
          this.gotDuration = false;
        }
      }
    },

    'startTime': {
      handler (val) {
        if (this.endTime - this.startTime < 1) {
          this.startTime = this.endTime - 1;
          this.updateSlider();
          this.updateBar();
          this.updateCounters();
        }
      }
    },

    'endTime': {
      handler (val) {
        if (this.endTime - this.startTime < 1) {
          this.endTime = this.startTime + 1;
          this.updateSlider();
          this.updateBar();
          this.updateCounters();
        }
      }
    }
  },
  components: {

  },
  created () {
    this.updateTimeData();
  },
  mounted () {
    this.buttons = [this.$refs.sliderButtonStart, this.$refs.sliderButtonEnd];
  },
  methods: {
    setTimeData () {
      let yes;
      let task = new Promise((resolve) => {
        yes = resolve;
      });
      let { videoStartTime, videoEndTime, type } = this.SelectScenes_Msg.background.data;

      this.startTime = videoStartTime || 0;
      this.endTime = videoEndTime || 0;
      this.startFormat = formatSecond(this.startTime);
      this.endFormat = formatSecond(this.endTime);

      this.SelectScenes_Msg
        .getMediaDurationByUrl()
        .then((dur) => {
          this.duration = dur;
          this.durationFormat = formatSecond(this.duration);

          this.endTime = Math.min(this.duration, this.endTime);
          this.endFormat = formatSecond(this.endTime);

          this.updateTimeData();
          yes();
        });

        return task;
    },

    setTimeDataLite ({
      videoStartTime,
      videoEndTime
    } = {}) {
      this.startTime = videoStartTime != null ? videoStartTime : this.startTime;
      this.endTime = videoEndTime != null ? videoEndTime : this.endTime;
      this.startFormat = formatSecond(this.startTime);
      this.endFormat = formatSecond(this.endTime);

      this.updateTimeData();
    },

    updateTimeData () {
      this.timeData = [
        {
          name: 'start',
          lang: '开始',
          value: this.startTime,
          format: this.startFormat,
          duration: this.duration,
          durationFormat: this.durationFormat
        }, {
          name: 'end',
          lang: '结束',
          value: this.endTime,
          format: this.endFormat,
          duration: this.duration,
          durationFormat: this.durationFormat
        }
      ]
    },

    setCounter ({
      action,
      timeDatum
    } = {}) {
      let { value } = timeDatum;
      if (value <= 0 && action === 'minus') {
        return;
      }
      if (value >= Math.floor(timeDatum.duration)
        && action === 'plus'
      ) {
        return;
      }
      if (timeDatum.name === 'start' && action === 'plus' && value >= this.endTime - 1) {
        return;
      }
      if (timeDatum.name === 'end' && action === 'minus' && value <= this.startTime + 1) {
        return;
      }
      let u = action === 'plus' ? 1 : -1;
      value += u;
      this[timeDatum.name + 'Time'] = value;
      this[timeDatum.name + 'Format'] = formatSecond(value);

      this.updateTimeData();
      this.updateSlider();
    },

    onDragged (params) {
      let {el, deltaX} = params;
      if (this.endTime - this.startTime > 1) {
        this.onDragged_(params);
      }
      if (
        this.endTime - this.startTime <= 1 &&
        (el.dataset.usage === 'end' && deltaX > 0 || el.dataset.usage === 'start' && deltaX < 0)
      ) {
        this.onDragged_(params);
      }
    },

    onDragged_ ({
      el,
      deltaX,
      offsetX,
      offsetY,
      clientX,
      first,
      last
    } = {}) {
      let runwayRect = this.getRunwayRect() || {};
      let { runwayLength } = this.slider;
      // console.log({offsetX, clientX, a: runwayRect.left, b: runwayRect.right})
      let buttonRects = [];
      buttonRects[1] = this.getRect(this.buttons[1]);
      if (el.dataset.usage === 'start' && clientX > buttonRects[1].left + buttonRects[1].width / 2) {
        // let u = this.exchange({currentTime: 1});
        // el.style.left = (parseFloat(this.buttons[1].style.left) - u) + 'px';
        this.startTime = this.endTime - 1;
        this.updateSlider();
        this.updateBar();
        this.updateCounters();
        return;
      }
      buttonRects[0] = this.getRect(this.buttons[0]);
      if (el.dataset.usage === 'end' && clientX < buttonRects[0].left - buttonRects[0].width / 2) {
        this.endTime = this.startTime + 1;
        this.updateSlider();
        this.updateBar();
        this.updateCounters();
        return;
      }
      if (clientX < runwayRect.left) {
        el.style.left = 0 + 'px';
        this.updateBar();
        this.updateCounters();
        return;
      }
      if (clientX > runwayRect.right) {
        el.style.left = runwayLength + 'px';
        this.updateBar();
        this.updateCounters();
        return;
      }

      let l = +window.getComputedStyle(el)['left'].slice(0, -2) || 0;
      let pos = 0;
      if (l <= 0 && deltaX < 0) {
        pos = 0;
      }
      else if (l >= runwayLength && deltaX > 0) {
        pos = runwayLength;
      }
      else {
        pos = l + deltaX;
      }
      if (pos < 0) {
        pos = 0;
      }
      if (pos > runwayLength) {
        pos = runwayLength;
      }
      el.style.left = pos + 'px';
      this.updateBar();
      this.updateCounters();
    },

    getRect(el) {
      return el.getBoundingClientRect();
    },

    getRunwayRect () {
      return this.$refs.runway && this.$refs.runway.getBoundingClientRect();
    },

    exchange ({pos, currentTime} = {}) {
      // pos / runwayLength = currentTime / duration
      if (pos != null) {
        return Math.round(pos / this.slider.runwayLength * this.duration);
      }
      if (currentTime != null) {
        return currentTime / this.duration * this.slider.runwayLength
      }
    },

    updateSlider () {
      let buttons = [this.$refs.sliderButtonStart, this.$refs.sliderButtonEnd];
      let s = this.exchange({currentTime: this.startTime});
      let e = this.exchange({currentTime: this.endTime});
      s = Math.round(s);
      e = Math.round(e);
      if (this.startTime === 0) {
        s = 0;
      }
      if (this.endTime === (this.duration | 0)) {
        e = this.slider.runwayLength;
      }

      if (s != null) {
        buttons[0].style.left = s + 'px'
      }

      if (e != null) {
        buttons[1].style.left = e + 'px'
      }

      this.updateBar();
    },

    updateCounters () {
      let buttons = [this.$refs.sliderButtonStart, this.$refs.sliderButtonEnd];
      let s = this.exchange({pos: +window.getComputedStyle(buttons[0])['left'].slice(0, -2) || 0});
      let e = this.exchange({pos: +window.getComputedStyle(buttons[1])['left'].slice(0, -2) || 0});

      this.setTimeDataLite({
        videoStartTime: s,
        videoEndTime: e
      })
    },

    updateBar () {
      let buttons = [this.$refs.sliderButtonStart, this.$refs.sliderButtonEnd];
      this.slider.barStart = +window.getComputedStyle(buttons[0])['left'].slice(0, -2) || 0
      this.slider.barEnd = +window.getComputedStyle(buttons[1])['left'].slice(0, -2) || 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/colors.scss";
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 332px;
	height: 202px;
  z-index: 35;
  border-radius: 6px 6px 3px 3px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }
}

.controls {
  &__slider {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  &__time {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.slider {
  height: 16px;
  // padding-left: 8px;
  &__runway {
    position: relative;
    width: 170px;
    height: 4px;
    border-radius: 4px;
    background-color: $c13;
    margin: 6px 0;
  }
  &__bar {
    height: 4px;
    border-radius: 4px;
    background-color: $c12;
  }
  &__button {
    position: absolute;
    top: -6px;
    margin-left: -1px;
    width: 2px;
    height: 18px;
    // border-radius: 16px;
    background-color: $c12;
    cursor: grab;

    &:after {
      content: '';
      position: absolute;
      top: 100%;
      width: 8px;
      height: 8px;
      background-color: $c12;
    }

    &.start {
      &:after {
        right: 0;
      }
    }
    &.end {
      &:after {
        left: 0;
      }
    }
  }
}

.counter{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
  &__name {

  }
  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__minus, &__plus {
    width: 22px;
    height: 22px;
    margin: 0 16px;
    background-color: $c13;
    border-radius: 2px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/videoBgDuration.vue